module.exports = __webpack_public_path__ + "static/media/fail-icon.0ea2a1a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/groupBuy/fail-icon.png
// module id = 1912
// module chunks = 6